/**
 * WONDR Safety Razor — reviews
 *
 * Desktop: cards are paginated in the 3-up grid, dots switch pages.
 * Mobile:  the grid becomes a native scroll-snap carousel so it can be swiped,
 *          and each dot maps to a single card.
 */
(function () {
  var MOBILE_QUERY = '(max-width: 768px)';

  function initReviews(root) {
    if (root.dataset.wondrSrzReviewsBound === 'true') return;
    root.dataset.wondrSrzReviewsBound = 'true';

    var grid = root.querySelector('[data-wondr-srz-review-grid]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wondr-srz-review-card]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-wondr-srz-review-dot]'));
    if (!grid || !cards.length) return;

    var perPage = parseInt(root.getAttribute('data-per-page') || '3', 10) || 3;
    var pages = Math.ceil(cards.length / perPage);
    var mq = window.matchMedia(MOBILE_QUERY);
    var isSwipe = false;
    var active = 0;
    var rafId = null;

    function setDots(current) {
      dots.forEach(function (dot, i) {
        dot.classList.toggle('is-active', i === current);
        dot.setAttribute('aria-current', i === current ? 'true' : 'false');
      });
    }

    /* --- Desktop: swap the visible cards in the grid --------------------- */

    function showPage(p) {
      active = Math.max(0, Math.min(p, pages - 1));
      cards.forEach(function (card, i) {
        var visible = i >= active * perPage && i < active * perPage + perPage;
        card.style.display = visible ? '' : 'none';
        if (visible) card.classList.remove('is-visible');
      });
      if (window.WondrSrz) window.WondrSrz.initFadeUp(grid);
      setDots(active);
    }

    /* --- Mobile: swipe between pages of stacked cards ------------------- */

    // Each page is one column, so its first card marks the snap position.
    function closestPageIndex() {
      var edge = grid.getBoundingClientRect().left;
      var best = 0;
      var bestDist = Infinity;
      for (var p = 0; p < pages; p++) {
        var card = cards[p * perPage];
        if (!card) continue;
        var dist = Math.abs(card.getBoundingClientRect().left - edge);
        if (dist < bestDist) {
          bestDist = dist;
          best = p;
        }
      }
      return best;
    }

    function onScroll() {
      if (rafId) return;
      rafId = window.requestAnimationFrame(function () {
        rafId = null;
        active = closestPageIndex();
        setDots(active);
      });
    }

    function scrollToPage(p, behavior) {
      var card = cards[Math.max(0, Math.min(p, pages - 1)) * perPage];
      if (!card) return;
      var left = card.getBoundingClientRect().left - grid.getBoundingClientRect().left + grid.scrollLeft;
      if (typeof grid.scrollTo === 'function') {
        grid.scrollTo({ left: left, behavior: behavior || 'smooth' });
      } else {
        grid.scrollLeft = left;
      }
    }

    function revealAllCards() {
      cards.forEach(function (card) {
        card.classList.add('is-visible');
      });
    }

    // The shared fade-up observer watches each card, but cards parked to the
    // right of the viewport never intersect until the track is swiped — so the
    // whole track reveals together as soon as the grid itself comes into view.
    function revealTrackOnEnter() {
      if (!('IntersectionObserver' in window)) {
        revealAllCards();
        return;
      }
      var obs = new IntersectionObserver(
        function (entries) {
          if (
            entries.some(function (entry) {
              return entry.isIntersecting;
            })
          ) {
            revealAllCards();
            obs.disconnect();
          }
        },
        { threshold: 0.08 }
      );
      obs.observe(grid);
    }

    function enableSwipe() {
      isSwipe = true;
      grid.classList.add('is-swipe');
      cards.forEach(function (card) {
        card.style.display = '';
      });
      revealTrackOnEnter();
      grid.addEventListener('scroll', onScroll, { passive: true });
      active = closestPageIndex();
      setDots(active);
    }

    function disableSwipe() {
      isSwipe = false;
      grid.classList.remove('is-swipe');
      grid.removeEventListener('scroll', onScroll);
      grid.scrollLeft = 0;
      showPage(0);
    }

    function applyMode() {
      if (mq.matches) {
        if (!isSwipe) enableSwipe();
      } else if (isSwipe) {
        disableSwipe();
      }
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var target = parseInt(dot.getAttribute('data-page'), 10) || 0;
        if (isSwipe) {
          scrollToPage(target);
        } else {
          showPage(target);
        }
      });
    });

    if (mq.matches) {
      enableSwipe();
    } else {
      showPage(0);
    }

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', applyMode);
    } else if (typeof mq.addListener === 'function') {
      mq.addListener(applyMode);
    }

    // Used by the theme editor so selecting a review block brings it into view.
    root.wondrSrzReviews = {
      goToCard: function (i) {
        var target = Math.floor(i / perPage);
        if (isSwipe) {
          scrollToPage(target);
        } else {
          showPage(target);
        }
      }
    };
  }

  function bootAll(scope) {
    (scope || document).querySelectorAll('[data-wondr-srz-reviews]').forEach(initReviews);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      bootAll();
    });
  } else {
    bootAll();
  }

  document.addEventListener('shopify:section:load', function (e) {
    bootAll(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    var card = e.target && e.target.closest && e.target.closest('[data-wondr-srz-review-card]');
    if (!card) return;
    var root = card.closest('[data-wondr-srz-reviews]');
    if (!root || !root.wondrSrzReviews) return;
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-wondr-srz-review-card]'));
    root.wondrSrzReviews.goToCard(cards.indexOf(card));
  });
})();
